import React from 'react'
import { Form, Icon, Input, Button, Checkbox } from 'antd'

const FormItem = Form.Item

class LoginFormComponent extends React.Component {
  handleSubmit = e => {
    e.preventDefault()
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.props.callback(values)
      }
    })
  }

  render() {
    const { getFieldDecorator } = this.props.form
    return (

      <Form onSubmit={this.handleSubmit} className="login-form">
        <FormItem>
          {getFieldDecorator('identifier', {
            rules: [{ required: true, message: 'Please input your username!' }],
          })(
            <Input prefix={<Icon type="user" style={{ color: 'rgba(0,0,0,.25)' }} />} placeholder="Username" />
          )}
        </FormItem>
        <FormItem>
          {getFieldDecorator('password', {
            rules: [{ required: true, message: 'Please input your Password!' }],
          })(
            <Input prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />} type="password" placeholder="Password" />
          )}
        </FormItem>
        <FormItem>
          

            <Button type="primary" htmlType="submit" className="login-form-button">
              Log in
            </Button>


        </FormItem>
      </Form>






      
    )
  }
}

const LoginForm = Form.create()(LoginFormComponent)
export default LoginForm



// WEBPACK FOOTER //
// ./src/containers/LoginPage/Login/LoginForm/index.js